<template>
  <div>
    <div class="mr-2 d-flex" 
        :style="'position: absolute; top: -20px; ' + 
          (parkPositionWagon === 'SX'?('left: ' + ((100 * carroConvoglio.posizioneBinario) / maxLengthFactor) + '%'):('right: ' + 
          ((100 * (carroConvoglio.posizioneBinario-deltaBinario)) / maxLengthFactor) + '%'))">
      <div v-if="isConvoglioInLavorazione && carroConvoglio.posizione === 1" class="mr-1 ml-3">
        <span v-if="carroConvoglio.viaggioIn && carroConvoglio.viaggioIn !== null">
          {{ viewNomeViaggio() ? carroConvoglio.viaggioIn.nome : carroConvoglio.viaggioIn.codice }}
        </span> 
        <span v-if="carroConvoglio.viaggioIn && carroConvoglio.viaggioIn !== null && carroConvoglio.viaggioOut && carroConvoglio.viaggioOut !== null">-</span>
        <span v-if="carroConvoglio.viaggioOut && carroConvoglio.viaggioOut !== null">
          {{ viewNomeViaggio() ? carroConvoglio.viaggioOut.nome : carroConvoglio.viaggioOut.codice }}
        </span>
      </div>
      <div v-if="isConvoglioInLavorazione && carroConvoglio.posizione === 1">
        <v-tooltip top color="grey lighten-2">
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon class="pa-0 ma-0" v-bind="attrs" v-on="on" style="background-color: rgba(255, 255, 255, 0.6);">
              <v-icon color="amber" large> mdi-progress-clock </v-icon>
            </v-btn>
          </template>
          <span> {{ $t("working") }}</span>
        </v-tooltip>
      </div>
    </div>

    <v-tooltip :top="this.numBinario < 5" :bottom="this.numBinario >= 5" color="#dfe0e1">
      <template v-slot:activator="{ on }">
        <div
          class="wagon"
          :style="wagonComputedStyle"
          v-on:click="wagonOnClick"
          v-on:dblclick="wagonOnDoubleClick"
          v-on:mouseover="mouseover = true"
          v-on:mouseleave="mouseover = false"
          v-on="on"
          :class="{ active: active }"
          @click.stop="toggleActive"
        >
          <div v-if="isCarroConvenzionale(carroConvoglio)" class="wagon-ctnr" stype="f44611" :style="`border: 2px solid #f44611`">
            <div class="conventional-wagon-ctnr" :style="`background:${getCarroConvenzionaleColorImport(carroConvoglio)}`" />
            <div class="conventional-wagon-ctnr" :style="`background:${getCarroConvenzionaleColorExport(carroConvoglio)}`" />
          </div>

          <div v-else class="wagon-ctnr">
            <div class="uties-ctnr">
              <div
                :class="`d-flex align-center justify-center uti ${features.length === 0 && utiCarro.remainOnBoardScarico ? 'uti-rob' : ''}`"
                v-for="(utiCarro, idx) in orderedImportUties"
                :key="utiCarro.id"
                :title="getUtiCode(utiCarro)"
                :style="calcUtiStyle(carroConvoglio, utiCarro, 'IMPORT', idx)"
              >
                <span v-if="yardShowing" class="text-caption font-weight-black">{{ getYardText(utiCarro) }}</span>
                <div v-else-if="features.length > 0" style="width: 13px; height: 13px" :class="getFeatureIcon(utiCarro).bgcolor">
                  <v-icon :color="getFeatureIcon(utiCarro).color" size="13">{{ getFeatureIcon(utiCarro).icon }}</v-icon>
                </div>
              </div>
            </div>

            <div class="uties-ctnr">
              <div
                :class="`d-flex align-center justify-center uti ${features.length === 0 && utiCarro.remainOnBoardScarico ? 'uti-rob' : ''}`"
                v-for="(utiCarro, idx) in orderedExportUties"
                :key="utiCarro.id"
                :title="getUtiCode(utiCarro)"
                :style="calcUtiStyle(carroConvoglio, utiCarro, 'EXPORT', idx)"
              >
                <span v-if="yardShowing" class="text-caption font-weight-black">{{ getYardText(utiCarro) }}</span>
                <div v-else-if="features.length > 0" style="width: 13px; height: 13px" :class="getFeatureIcon(utiCarro).bgcolor">
                  <v-icon :color="getFeatureIcon(utiCarro).color" size="13">{{ getFeatureIcon(utiCarro).icon }}</v-icon>
                </div>
              </div>
            </div>
          </div>

          <v-sheet :color="getWagonFeatureColor(carroConvoglio, danniCarroConvoglio.length > 0, features)" height="5" class="wagon-feature mt-1" />
        </div>
      </template>
      <div style="width: 450px">
        <wagonInfoPanel :carro="carroConvoglio" :convoglio="convoglioSel" tooltip />
      </div>
    </v-tooltip>
  </div>
</template>

<script>
import convoyVisualizationMixins from "./mixins/convoyVisualizationMixins";
import wagonInfoPanel from "../misc/WagonInfoPanel.vue";

export default {
  name: "wagon",
  components: {
    wagonInfoPanel,
  },
  props: {
    carroConvoglio: {
      type: Object,
      required: true,
    },
    convoglioSel: {
      type: Object,
      required: false,
    },
    maxLengthFactor: {
      type: Number,
      default: 200,
    },
    utiSearchParam: {
      type: String,
      default: "",
    },
    wagonSearchParam: {
      type: String,
      default: "",
    },
    plannedShowing: {
      type: Boolean,
      default: false,
    },
    features: {
      type: Array,
      default: () => [],
    },
    yardShowing: {
      type: Boolean,
      default: false,
    },
    numBinario: {
      type: Number,
    },
    active: {
      type: Boolean,
    },
    index: {
      type: Number,
    },
    shipFilterEnabled: {
      type: Boolean,
      default: false,
    },
    shipColors: {
      type: Object,
      default: () => ({}),
    },
    parkPositionWagon: {
      type: String,
      default: "SX",
    },
    filteredShips: {
      type: Array,
      default: () => [],
    },
    isConvoglioInLavorazione: {
      type: Boolean,
      default: false,
    },
    deltaBinario: {
      type: Number,
      default: 0.0
    }
  },
  mixins: [convoyVisualizationMixins],
  data() {
    return {
      zIndex: 99,
      detailOpened: false,
      mouseover: false,
      danniCarroConvoglio: [],
      activeIndex: 0,
    };
  },
  async mounted() {
    this.danniCarroConvoglio = await this.$api.get(this.$apiConfiguration.BASE_PATH + "logDanni/carroConvoglio/" + this.carroConvoglio.id);
  },
  methods: {
    toggleActive() {
      this.$emit("set-active", this.index);
      console.log(this.index);
      console.log(this.active);
      console.log(this.activeIndex);
    },
    wagonOnClick() {
      setTimeout(() => {
        this.$eventBus.$emit("wagonSelected", this.carroConvoglio);
      }, 300);
    },
    wagonOnDoubleClick() {
      this.$eventBus.$emit("convoySelected", this.carroConvoglio.convoglioId);
    },
    calcWidth() {
      return (100 * this.getCarroLength(this.carroConvoglio)) / this.maxLengthFactor;
    },
    calcPosition() {
      return (100 * this.carroConvoglio.posizioneBinario) / this.maxLengthFactor;
    },
    getUtiBorderStyle(utiCarro, idx) {
      // console.log("getUtiBorderStyle --------------- ", utiCarro, idx);
      const utiCode = this.getUtiCode(utiCarro).toLowerCase();
      let carrierOut = this.getCarrierOut(utiCarro);
      carrierOut = carrierOut ? carrierOut.toLowerCase() : "";
      let serviceOut = this.getServiceOut(utiCarro);
      serviceOut = serviceOut ? serviceOut.toLowerCase() : "";

      const searchPar = this.utiSearchParam.toLowerCase();

      if (
        this.utiSearchParam &&
        ((this.utiSearchParam.length >= 3 && (utiCode.includes(searchPar) || carrierOut.includes(searchPar) || serviceOut.includes(searchPar))) ||
          utiCode === searchPar ||
          carrierOut === searchPar ||
          serviceOut === searchPar)
      ) {
        return { border: "2px solid #fdf905" };
      } else if (this.features.includes("EMP") && utiCarro.visitaUti.fullEmpty === "E") {
        return { border: "2px solid #000000" };
      } else if (
        this.features.includes("HCB") &&
        ((utiCarro.visitaUti.uti && utiCarro.visitaUti.uti.altezza === 9.6) || (utiCarro.visitaUti.tipoUti && utiCarro.visitaUti.tipoUti.altezzaEsterna === 9.6))
      ) {
        return { "border-top-style": "solid", "border-width": idx === 0 ? "2px 0px 1px 0px" : "2px 0px 1px 1px" };
      } else {
        return this.calcBorder(idx);
      }
    },
    getSpatialInfoError(utiCarro) {
      if (this.features.includes("ERR") && this.wagonSpatials[utiCarro.tipoMovimento.toLowerCase()].warn)
        return {
          "-webkit-box-shadow": "inset 0px 0px 0px 2px #f00",
          "-moz-box-shadow": "inset 0px 0px 0px 2px #f00",
          "box-shadow": "inset 0px 0px 0px 2px #f00",
        };

      return {};
    },
    getWagonBorderStyle() {
      if (this.mouseover) {
        return "border: 2px solid #333333;";
      }
      const licensePlate = this.getCarroLicensePlate(this.carroConvoglio);
      if (
        this.wagonSearchParam &&
        ((this.wagonSearchParam.length >= 3 && licensePlate.includes(this.wagonSearchParam.toLowerCase())) || licensePlate === this.wagonSearchParam.toLowerCase())
      ) {
        return "border: 2px solid #fdf905;";
      }
      return "border-right: 2px dashed #000000;";
    },
    getFeatureIcon(utiCarro) {
      var featsIcons = [];
      let isPericoloso = false;
      if (this.features.includes("IMO")) {
        if (!!utiCarro.visitaUti.dangerousIndicator) {
          isPericoloso = utiCarro.visitaUti.dangerousIndicator;
        } else if (utiCarro.visitaUti.uti) {
          isPericoloso = !!utiCarro.visitaUti.uti.pericoloso;
        } else if (utiCarro.visitaUti.tipoUti) {
          isPericoloso = !!utiCarro.visitaUti.tipoUti.pericoloso;
        }
      }
      if (isPericoloso) {
        featsIcons.push({ icon: "mdi-rhombus", color: "error", bgcolor: null });
      }

      let isReefer = false;
      if (this.features.includes("REE")) {
        // console.log("operationalReefer", utiCarro.visitaUti.id, utiCarro.visitaUti.operationalReefer);
        if (!!utiCarro.visitaUti.operationalReefer) {
          isReefer = utiCarro.visitaUti.operationalReefer;
        } else if (utiCarro.visitaUti.uti) {
          isReefer = !!utiCarro.visitaUti.uti.reefer;
        } else if (utiCarro.visitaUti.tipoUti) {
          isReefer = !!utiCarro.visitaUti.tipoUti.reefer;
        }
      }
      if (isReefer) {
        featsIcons.push({ icon: "mdi-snowflake", color: "white", bgcolor: "light-blue lighten-1" });
      }

      let is29tons = this.features.includes("TON") && utiCarro.visitaUti.pesoLordo > 29000;
      if (is29tons) {
        featsIcons.push({ icon: "mdi-weight", color: "black", bgcolor: null });
      }

      if (featsIcons.length > 1) {
        featsIcons = [{ icon: "mdi-checkbox-multiple-blank-outline", color: "black", bgcolor: null }];
      }

      var featsIcon = featsIcons.length > 0 ? featsIcons[0] : { icon: "", color: "white", bgcolor: null };
      // console.log("featsIcon ------- ", featsIcon.icon, featsIcon.color);
      return featsIcon;
    },
    calcUtiStyle(carroConvoglio, utiCarro, impexp, idx) {
      // console.log("this.wagonSpatials",this.wagonSpatials);
      const style = {
        ...this.calcUtiCompWidth(this.wagonSpatials, utiCarro.id, impexp),
        ...this.getUtiBorderStyle(utiCarro, idx),
        ...this.getSpatialInfoError(utiCarro),
      };

      if (this.shipFilterEnabled) {
        const utiCarrierOutVoy = utiCarro.visitaUti?.carrierOutVoy;
        const isUtiShipSelected = this.filteredShips.includes(utiCarrierOutVoy);

        if (isUtiShipSelected) {
          const shipColorData = this.shipColors[utiCarrierOutVoy];
          if (shipColorData) {
            style.background = shipColorData.colore;
          } else {
            style.background = "#CCCCCC";
          }
        } else {
          style.background = "#ffffff";
          style.opacity = "0.6";
        }
      } else {
        Object.assign(style, this.getUtiColorStyle(utiCarro));
      }
      // console.log("---------------------- calcUtiStyle", utiCarro.utiCodice, impexp, idx, style);
      return style;
    },

    getShipIdFromUti(utiCarro) {
      console.log("colore nave:", utiCarro.visitaUti?.coloreNave);
      return utiCarro.visitaUti?.coloreNave || null;
    },
  },
  computed: {
    unchargedImportUtiNumber() {
      return this.getUnchargedImportUtiNumber(this.carroConvoglio);
    },
    unchargedExportUtiNumber() {
      return this.getUnchargedExportUtiNumber(this.carroConvoglio);
    },
    chargedImportUtiNumber() {
      return this.getChargedImportUtiNumber(this.carroConvoglio);
    },
    chargedExportUtiNumber() {
      return this.getChargedExportUtiNumber(this.carroConvoglio);
    },
    orderedImportUties() {
      if (!this.plannedShowing) {
        return this.getRTOrderedImportUties(this.carroConvoglio);
      }
      return this.getOrderedImportUties(this.carroConvoglio);
    },
    orderedExportUties() {
      if (!this.plannedShowing) {
        return this.getRTOrderedExportUties(this.carroConvoglio);
      }
      return this.getOrderedExportUties(this.carroConvoglio);
    },
    width() {
      return this.calcWidth();
    },
    position() {
      return this.calcPosition();
    },
    licensePlate() {
      return this.getCarroLicensePlate(this.carroConvoglio);
    },
    wagonSpatials() {
      return this.calcWagonSpatials(this.carroConvoglio);
    },
    wagonComputedStyle() {
      const baseStyle = {
        zIndex: this.zIndex,
        width: `${this.width}%`,
        ...this.getWagonBorderStyle(),
      };

      if (this.parkPositionWagon === "DX") {
        return {
          ...baseStyle,
          right: `${(100 * (this.carroConvoglio.posizioneBinario-this.deltaBinario)) / this.maxLengthFactor}%`,
        };
      } else {
        return {
          ...baseStyle,
          left: `${(100 * this.carroConvoglio.posizioneBinario) / this.maxLengthFactor}%`,
        };
      }
    },
  },
  watch: {
    mouseover: function (newValue) {
      if (newValue) {
        this.$eventBus.$emit("convoyHighlighted", this.carroConvoglio.idConvoglio);
      } else {
        this.$eventBus.$emit("convoyDeHighlighted");
      }
    },
  },
};
</script>

<style scoped>
.wagon {
  position: absolute;
  height: 40px;
  margin-top: 20px;
  border-right: 2px dashed #1b1b0f;
  background: rgba(105, 105, 105, 0.5);
  overflow: visible;
}

.wagon-feature {
  border-top-left-radius: 0px !important;
  border-bottom-left-radius: 3px !important;
  border-top-right-radius: 0px !important;
  border-bottom-right-radius: 3px !important;
}

/* .conventional-wagon-ctnr{
    height: 100%;
    width: 100%;
    background: #af9778;
} */
.conventional-wagon-ctnr {
  height: 50%;
  width: 100%;
  float: left;
}

.wagon-ctnr {
  height: 100%;
  width: 100%;
}

.uties-ctnr {
  height: 50%;
  width: 100%;
  float: left;
}

.uti {
  height: 100%;
  float: left;
  border-color: #333333;
  border-style: dashed;
  border-collapse: collapse;
  font-size: 0.3rem;
  overflow: hidden;
}

.uti-number {
  height: 100%;
  width: 50%;
  float: left;
  text-align: center;
  font-size: 0.6rem;
  overflow: hidden;
}

.uti-rob {
  background-image: repeating-linear-gradient(-45deg, #ffffff, #ffffff 5px, rgb(196, 196, 192) 5px, rgb(196, 196, 192) 10px) !important;
}

.uti i {
  font-size: 0.6rem;
  font-weight: bold;
  float: right;
}

.uti-danger-icon {
  color: red;
}

.uti-text {
  width: 100%;
  height: 100%;
  text-align: center;
}

.uti-text > span {
  margin: 0 auto;
  word-wrap: break-word;
}

.uti-text b {
  word-wrap: break-word;
}

/* .wagon-details{
    height: 20%;
    width: 100%;
    float: left;
    background: #615c59;
    overflow: hidden;
    vertical-align: middle;
}
.wagon-details > span{
    font-size: 0.4rem;
    font-weight: bold;
    line-height: 7px;
    color: #f9fafb;    
    text-align: center;
    display: block;
} */
.active {
  border: 2px solid #333333 !important;
}
</style>
